import { Heading, HeadingProps } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

interface PageTitleProps extends HeadingProps {
  children: ReactNode;
}

export const PageTitle = ({ children, ...rest }: PageTitleProps) => {
  return (
    <Heading as="h4" fontWeight="300" mb={5} {...rest}>
      {children}
    </Heading>
  );
};
